import { Link as RouterLink } from "react-router-dom"
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core"
import NotificationsBell from "./NotificationsBell"
import useGuardiaNotificationFeed from "./useGuardiaNotificationFeed"

const GuardiaNotifications = () => {
  const { title, total, visitasAnticipadas } = useGuardiaNotificationFeed()

  return (
    <NotificationsBell title={title} total={total}>
      <List
        disablePadding
        style={{ maxHeight: "400px", width: "100%", maxWidth: "400px" }}
      >
        {visitasAnticipadas.length > 0 ? (
          <List component="div" disablePadding>
            {visitasAnticipadas.slice(-5).map(item => (
              <ListItem
                component={RouterLink}
                divider
                key={item.id}
                to="/guardia/visitasAnticipadas"
              >
                <ListItemText
                  primary={
                    <>
                      <Typography variant="body2">
                        Lugar: {item.CasaDestino}
                      </Typography>
                      <Typography variant="body2">{"\n"}</Typography>
                      <Typography variant="body2">
                        Nombre: {item.Nombre} {item.Apellido}
                      </Typography>
                      <Typography variant="body2">{"\n"}</Typography>
                      <Typography variant="body2">
                        Residente: {item.NombreDestino} {item.ApellidoDestino}
                      </Typography>
                      <Typography variant="body2">{"\n"}</Typography>
                      <Typography variant="body2">
                        Hora: {item.HoraEstimadaLlegada}
                      </Typography>
                    </>
                  }
                  primaryTypographyProps={{
                    variant: "subtitle2",
                    color: "textPrimary",
                  }}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box p={2} display="flex" justifyContent="center">
            <Typography color="textPrimary">
              No tiene Visitas anticipadas para hoy
            </Typography>
          </Box>
        )}
        <Box display="flex" justifyContent="center">
          <Button
            component={RouterLink}
            size="small"
            to="/guardia/visitasAnticipadas"
          >
            ir a visitas
          </Button>
        </Box>
      </List>
    </NotificationsBell>
  )
}

export default GuardiaNotifications
